<template>
  <div class="flex flex-wrap gap-2 text-xs">
    <span v-if="lanParty.play_mode" class="inline-flex items-center gap-1.5 bg-gray-800 text-text-primary rounded-md px-2 py-1">
      <svg class="w-3.5 h-3.5 text-text-secondary" viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="7.5" /><path d="M12 2.25v4.5m0 10.5v4.5M2.25 12h4.5m10.5 0h4.5" /></g></svg>
      {{ lanParty.play_mode.friendly_name }}
    </span>
    <span v-if="lanParty.cs_map" class="inline-flex items-center gap-1.5 bg-gray-800 text-text-primary rounded-md pl-1.5 pr-2 py-0.5">
      <img :src="pinUrl(lanParty.cs_map.name)" alt="" class="w-6 h-6 object-contain" />
      {{ lanParty.cs_map.friendly_name }}
    </span>
    <span class="inline-flex items-center gap-1.5 bg-gray-800 text-text-primary rounded-md px-2 py-1">
      <GlobeAltIcon class="w-3.5 h-3.5 text-text-secondary" aria-hidden="true" />
      {{ lanParty.region.name }}
    </span>
  </div>
</template>

<script setup>
import { GlobeAltIcon } from '@heroicons/vue/24/outline';
import { pinUrl } from '../../utils/lan_party';

defineProps({
  lanParty: { type: Object, required: true },
});
</script>
